module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addToCalendar":"Zum Kalender hinzufügen","back":"Zurück","completion":"Abschluss","eventDetails":"Veranstaltungsdetails","next":"Weiter","personalDetails":"Personalien","send":"Absenden"},"en":{"addToCalendar":"Add to calendar","back":"Back","completion":"Completion","eventDetails":"Event details","next":"Next","personalDetails":"Personal details","send":"Send"}}')
  delete Component.options._Ctor
}
